import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import { useSelector, useDispatch } from "react-redux";
import { setUserLogin } from "../../redux/Slices/userSlice";
import { toast } from "react-toastify";
import { putAdminUser } from "../../connections/putAdminUser";

const UpdateAdminUser = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const location = useLocation();
  const adminUserData = location.state || null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "" || adminUserData?.email,
    password: "" || adminUserData?.password,
    password_confirmation: "" || adminUserData?.password_confirmation,
    name:"" || adminUserData?.name,
    
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      toast.error("Email is required");
      return;
    }
    if (!formData.password) {
      toast.error("Password is required");
      return;
    }
    if (!formData.password_confirmation) {
      toast.error("Password Confirmation is required");
      return;
    }
    if (!formData?.name) {
      toast.error("Name is required");
      return;
    }

    const payload = {
      admin_user: formData,
    };

    try {
      const result = await putAdminUser(
        user?.token,
        payload,
        adminUserData?.id
      );
      if (result?.status?.status === "SUCCESS") {
        toast.success("Admin User Updated Successfully");

        // If updated email matches logged-in user, sync localStorage + Redux
        const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
        if (storedUser?.email === adminUserData?.email) {
          const updatedUser = {
            ...storedUser,
            email: formData.email,
            name: formData.name,
          };
          localStorage.setItem("user", JSON.stringify(updatedUser));
          dispatch(setUserLogin(updatedUser));
        }

        navigate(-1);
        setFormData({
          email: "",
          password: "",
          password_confirmation: "",
          name: "",
        });
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="admin-user-list" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={-1}>Admin User</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Update Admin User</li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    {adminUserData?.id}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Admin User</h4>
                        </div>
                      </div>
                         <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Name <span className="login-danger">*</span>
                          </label>
                          <input
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            required={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            required={true}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Password <span className="login-danger">*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <input
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                              className="form-control"
                              type={showPassword ? "text" : "password"}
                              required={true}
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              <FeatherIcon icon={showPassword ? "eye-off" : "eye"} size={16} />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Password Confirmation{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <input
                              name="password_confirmation"
                              value={formData.password_confirmation}
                              onChange={handleChange}
                              className="form-control"
                              type={showConfirmPassword ? "text" : "password"}
                              required={true}
                            />
                            <span
                              onClick={() => setShowConfirmPassword((prev) => !prev)}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              <FeatherIcon icon={showConfirmPassword ? "eye-off" : "eye"} size={16} />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                          >
                            Update Admin User
                          </button>
                          <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="btn btn-primary cancel-form"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateAdminUser;
